import React, { useEffect } from 'react'
import NavBar from './components/NavBar'
import { Box, Stack } from '@mui/material'
import AppRoutes from './routes/AppRoutes'
import Login from './components/user/Login'
import Notification from './components/Notification'
import Loading from './components/Loading.tsx'
import { useAppStore } from './store/appStore.tsx'
import { useNavigate } from 'react-router-dom';
import { useValue } from './context/ContextProvider.js'

const App = () => {

    const currentUser = useAppStore(appStore => appStore.currentUser);
    const { dispatch } = useValue();
    //console.log(currentUser);
    const navigate = useNavigate();

    useEffect(() => {
        //const currentUserSaved = JSON.parse(localStorage.getItem('currentUser'));
        //updateUser(currentUserSaved);
        //if(!currentUserSaved || currentUserSaved?.token < 10) {
        //  navigate('/');
        //}
        if (currentUser?.id === 0) {
            //console.log(currentUser);
            navigate('/');
        }

        if (currentUser?.mustChangePassword) {
            dispatch({ type: 'OPEN_PASSWORD_MODAL', payload: {open: true}});
        }
    }, [currentUser, dispatch]);



    return (
        <>
            <Loading />
            <Box sx={{ minHeight: '100vh', backgroundColor: '#fff', overflow: 'auto' }} pl={2} pr={2} >
                <Login />
                <Stack direction="column" justifyContent={'top'} style={{ minHeight: '100vh' }}>
                    <NavBar />
                    <Notification />
                    <AppRoutes />
                </Stack>
            </Box>
        </>
    )
}

export default App;
